import React from 'react';
import { Link } from 'react-router-dom';
import path from 'path';
import Tooltip from 'mrf/view/Tooltip';
import { ViewIcon } from 'styles/components/Icons';
import { generateHtmlId } from 'mrf/utils/StringGenerators';

export default function ViewButton({ match, id, relativePath, absolutePath, size = 30 }) {
    const to = (relativePath || id)
        ? path.join(match.url, relativePath || `view/${id}`)
        : absolutePath;

    const htmlId = generateHtmlId('view', relativePath || id || absolutePath);

    return <Link
        to={to}
        id={htmlId}
        name={generateHtmlId('view', 'link')}
    >
        <Tooltip content='View'>
            <ViewIcon size={size} />
        </Tooltip>
    </Link>;
}
